import React, { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { isEmpty, reject } from 'lodash';
import ButtonLink from 'components/theme_components/ButtonLink';

import {
  Button,
  Card,
  Col,
  Collapse,
  Form,
  Input,
  List,
  notification,
  Row,
  Spin,
  Typography,
} from 'antd';
import Text from 'antd/lib/typography/Text';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import RouterLink from 'components/RouterLink';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  findByTpReferenceAndTpName,
  FindByTpReferenceAndTpNameParams,
  TpList,
} from 'services/thirdParty';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput, {
  ThirdPartyForProposalType,
} from 'components/ThirdPartyInput';
import TitlePage from 'components/theme_components/Title';
import FormInput from 'components/FormInput';
import SearchButton from 'components/SearchButton';
import {
  ExclamationCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import { useForm } from 'antd/lib/form/Form';
import NewButton from 'components/NewButton';
import ResetButtonAction from '../ResetButtonAction';
import SubmitButtonAction from '../SubmitButtonAction';

const { Panel } = Collapse;

export type ThirdPartySearchProps = {
  onSelect?: (item: TpList) => void;
  isProposalCreate?: boolean;
  setThirdPartyForProposal?: (
    ThirdPartyForProposal: ThirdPartyForProposalType
  ) => void;
  parcodeRole?: string;
};

const ThirdPartyList = ({ }: ThirdPartySearchProps) => {
  const initialSearchParams: FindByTpReferenceAndTpNameParams = {
    parentid: 0,
    role: '',
    tpfiscalid: '',
    tpname: '',
    tpreference: '',
    tpcardid: '',
    tptype: '',
  };
  const [searchParams, setSearchParams] =
    useState<FindByTpReferenceAndTpNameParams>(initialSearchParams);

  const [form] = useForm();

  const [search, setSearch] = useState(false);
  const [tpList, setTpList] = useState<any[]>([]);
  const [createNewTP, setCreateNewTP] = useState<any>();

  const searchThirdparty = useCallback((tprefernce: string) => {
    console.log(searchParams);
    findByTpReferenceAndTpName({ ...searchParams, tpreference: tprefernce })
      .then((response) => {
        if (response.code === '200') {
          setTpList(response.list);
        } else if (response.code === '404') {
          setCreateNewTP(true);
        }
      })
      .catch((response) => {
        notification.error({
          message: response.message,
        });
        setTpList([]);
      });
  }, []);
  const keywordSearch = (e: any) => {
    if (e.target.value.length === 0 || e.target.value.length >= 3) {
      searchThirdparty(e.target.value);
    } else {
      return;
    }
  };

  return (
    <DF.Provider pagcode="tpsfslist">
      <div  >
        <TitlePage level={2} comcode="newTp"></TitlePage>
        <>
          <div className='container'>
            <Row justify="center">
              <Col span={24}>
                <Form form={form}>
                  <Form.Item name="tpreference" className="sfs_style" noStyle>
                    <p>Rechercher ou créer un RRDI</p>
                    <Input
                      className="ut-input-search"
                      onChange={(e) => {
                        keywordSearch(e);
                      }}
                      addonAfter={
                        <SearchOutlined
                          onClick={(e: any) => {
                            searchThirdparty;
                          }}
                        />
                      }
                    />
                    <p style={{ color: '#979393dd' }} className="ut-input-search-notif mt-1">
                      <ExclamationCircleOutlined /> Recherche si déja existant dans
                      BUIC{' '}
                    </p>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
            {createNewTP ? (
              <Row justify="center">
                <Col span={24}>
                  <p className='mt-3'>Aucun résultat trouvé dans BUIC.</p>
                  <Row className='d-flex justify-between align-center'>
                    <Col xs={18}>
                      <p>
                        Voulez-vous créer un nouveau tiers avec cette référence ?{' '}
                      </p>
                    </Col>
                    <Col xs={6} className='d-flex justify-end'>
                      <ResetButtonAction comcode='Annuler' className='mr-4' />
                      <ButtonLink comcode='Valider' to={`/thirdparty-sfs/create`} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : tpList ? (
              <Row justify="center">
                <Col span={24}>
                  <List
                    dataSource={tpList}
                    pagination={{ pageSize: 8 }}
                    renderItem={(e) => (
                      <List.Item className='no-border'>
                        <Card className='w-100 no-border'>
                          <Row className='align-center'>
                            <Col xs={18}>
                              <p className='font-size-15'>{e?.tpreference}</p>
                              <h3 className='font-size-18'>{e?.tpname}</h3>
                              <p className='font-size-15'>{e.tptype == 'PM' ? 'Company' : 'Individual'}</p>
                            </Col>
                            <Col xs={6} className='text-right'>
                              {' '}
                              {/* <RouterLink
                            type="primary"
                            style={{
                              width: '100%',
                              height: '40px',
                              padding: '15px',
                              color:"#ffff"
                            }}
                            component={Button}
                            to={`/third-party/${e.tpid}/TP`}
                          >
                            Selectionner ce tier
                            </RouterLink> */}
                              <ButtonLink comcode='Selectionner ce tier' to={`/thirdparty-sfs/${e.tpid}/TP`} />
                            </Col>
                          </Row>
                        </Card>
                      </List.Item>
                    )}
                  />
                </Col>
              </Row>
            ) : (
              ''
            )}
          </div>
        </>
      </div>
    </DF.Provider>
  );
};

export default ThirdPartyList;
